<template>
  <FullCalendar
    class="dashboard-day"
    ref="fullCalendar"
    defaultView="dayGridDay"
    editable="false"
    header="false"
    :contentHeight="contentHeight"
    :eventLimit="eventsLimit"
    eventLimitText=""
    :plugins="calendarPlugins"
    :events="calendarEvents"
    @eventClick="onEventClick"
    navLinks="false"
    :navLinkDayClick="handleDateClick"
    :dayRender="dayRender"
    :viewSkeletonRender="onRender"
    @eventDrop="eventDrop"
    :defaultDate="getDate"
    :columnHeader="hideWeekDay"

  />
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from 'moment'

const CONTENT_HEIGHT_FULL = 150
const EVENTS_LIMIT = 3
/**
 * It's component that is absent in final version of the application.
 * This one may be in demand in the future
 */
export default {
  name: 'DashboardDay',
  components: {
    FullCalendar
  },
  created () {
    this.prepareData()
  },
  props: {
    events: {
      type: Object,
      required: true
    },
    date: {
      type: Object
    }
  },
  data: function () {
    return {
      calendarPlugins: [
        dayGridPlugin,
        interactionPlugin
      ],
      calendarEvents: [],
      contentHeight: CONTENT_HEIGHT_FULL,
      eventsLimit: EVENTS_LIMIT,
      hideWeekDay: false
    }
  },
  methods: {
    dayRender ({ date, el, view }) {
      if (moment().isSame(date, 'day')) {
        el.style = 'background-color: #f8f8f8;'
      } else {
        el.style = 'background-color: white;'
      }
    },
    onEventClick ({ event, jsEvent }) {
      jsEvent.preventDefault()
      const calendarEvent = this.calendarEvents.find(item => {
        return item._id === event.id
      })
      if (calendarEvent.type === 'link') {
        let routeData = this.$router.resolve({
          name: 'briefContent',
          params: { id: calendarEvent._id }
        })
        window.open(routeData.href, '_blank')
      } else if (calendarEvent.link) {
        window.open(calendarEvent.link, '_blank')
      }
    },
    prepareData: function () {
      this.calendarEvents = this.events.map(event => {
        const classNames = event.type === 'link' ? ['calendar__brief'] : ['calendar__event']
        if (event.type === 'event' && !event.link) {
          classNames.push('calendar__cell_disabled')
        }
        return {
          ...event,
          title: event.name,
          start: new Date(event.start_date.replace(/ /g, 'T')),
          id: event._id,
          classNames
        }
      })
    }
  },
  computed: {
    getDate () {
      return moment(this.date).toDate()
    }
  }
}
</script>

<style lang="scss">
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';

  /*table*/
  .dashboard-day {

    .fc-toolbar {
      display: none !important;
    }

    /*events*/
    .fc-content {
      height: 24px;
      display: flex;
      align-items: center;
      margin: 5px 20px;
    }

    .fc-title {
      @include ellipsis
    }

    .fc-event {
      border: none !important;
    }

    .fc-time {
      display: none;
    }

    .fc-center h2 {
      text-transform: uppercase;
      font-weight: normal;
      font-size: 24px;
      color: $rfx-dark-march;
    }

    .fc-event-container {
      padding: 0 10px !important;
    }

    .fc-more-cell {
      display: flex;
      justify-content: flex-end;
      font-size: 16px;
      color: $rfx-bright-blue;
      padding: 0 5px !important;
    }

    .fc-popover {
      left: 0 !important;
      width: 200px !important;
    }
  }
</style>
